<template />
<script>
import wx from 'weixin-js-sdk'

export default {
  name: 'Wechat',
  data() {
    return {}
  },
  created() {
    wx.miniProgram.redirectTo({ url: '/pages/login/login?code=' + this.$route.query.code })
  }
}
</script>
